import {Component} from '@angular/core';
import {ActivatedRoute, Router, RouterLinkWithHref} from '@angular/router';
import {combineLatest} from 'rxjs';
import {AuthService, HitCommonModule, RecursiveHelper} from '@hassel-it/angular-common';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {faKey} from '@fortawesome/free-solid-svg-icons';
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-finish-reset-password',
    templateUrl: './finish-reset-password.component.html',
    standalone: true,
    imports: [
        NgClass,
        NgForOf,
        HitCommonModule,
        FormsModule,
        NgIf,
        RouterLinkWithHref
    ]
})
export class FinishResetPasswordComponent {

    faKey = faKey;

    logginIn: any;
    loginData = {password: null, password_confirm: null, temp_password: null, uuid: null};

    alertMode: string;
    alertStrings: string[] = [];

    constructor(
        private router: Router,
        private modalService: NgbModal,
        public activatedroute: ActivatedRoute, public authService: AuthService) {

        combineLatest([this.activatedroute.paramMap, this.activatedroute.data, this.activatedroute.queryParams
        ]).subscribe(([paramMap, data, queryParams]) => {
            this.loginData.temp_password = queryParams.key;
            this.loginData.uuid = queryParams.uuid;
        });

    }

    submit() {
        this.alertStrings = [];
        this.authService.finishReset(this.loginData).then((restul) => {
            this.alertMode = 'success';
            this.alertStrings = ['Din nye kode er nu oprettet, og du kan logge ind.'];
            this.logginIn = false;
            this.loginData.password = null;
            this.loginData.password_confirm = null;
        }, (error) => {
            this.alertMode = 'danger';
            RecursiveHelper.recursiveFunction(error.error.errors, (path, value, key) => {
                this.alertStrings.push(value);
            });
            this.logginIn = false;
        });
    }
}
